"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58263],{

/***/ 402714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(629909);
var grid = __webpack_require__(793767);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var VideoPreviewLayout = /* @__PURE__ */ ((VideoPreviewLayout2) => {
  VideoPreviewLayout2["Vertical"] = "vertical";
  VideoPreviewLayout2["Overlay"] = "overlay";
  return VideoPreviewLayout2;
})(VideoPreviewLayout || {});
var VideoPreviewDisplayType = /* @__PURE__ */ ((VideoPreviewDisplayType2) => {
  VideoPreviewDisplayType2["ProductCard"] = "product_card";
  VideoPreviewDisplayType2["ShortDescription"] = "short_description";
  return VideoPreviewDisplayType2;
})(VideoPreviewDisplayType || {});
var VideoPreviewWidthType = /* @__PURE__ */ ((VideoPreviewWidthType2) => {
  VideoPreviewWidthType2["FullWidth"] = "fullWidth";
  VideoPreviewWidthType2["HugContent"] = "hugContent";
  return VideoPreviewWidthType2;
})(VideoPreviewWidthType || {});
const BASE_VIDEO_PREVIEW_LIST_DATA = {
  widthType: "fullWidth" /* FullWidth */,
  layout: "vertical" /* Vertical */,
  displayType: "product_card" /* ProductCard */,
  titleColor: "#000000",
  viewMoreStyle: {
    color: "#000000"
  },
  items: [
    {
      videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
      title: "video preview 1"
    },
    {
      videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
      title: "video preview 2"
    }
  ],
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const VIDEO_PREVIEW_ITEM_STYLE = {
  borderRadius: 12
};
const DEFAULT_VIDEO_PREVIEW_LIST = __spreadProps(__spreadValues({}, BASE_VIDEO_PREVIEW_LIST_DATA), {
  itemStyle: VIDEO_PREVIEW_ITEM_STYLE,
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE),
    itemPerView: 5
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    }),
    itemPerView: 1.5
  }
});
const VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP = 288;
const VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP = 24;
const VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE = 8;
const MAX_VIDEO_ITEM_MOBILE = 3;
const PRODUCT_REVIEW_EXAMPLE = {
  sku: "1",
  sellerSku: "LINH004",
  name: "Tr\xE0 xanh C2 \u1ED5i h\u1ED3ng chanh d\xE2y 455ml",
  imageUrl: "https://lh3.googleusercontent.com/gtOHWQvi2DXbJg8oNW5-4kx0DMzU_JkVtqYOVcI3WNhI_euoaDDeOpKRMUo9GDl3KC8JbLQhClqYSIwY44_2-UArEvOFliU",
  price: {
    latestPrice: 121200,
    supplierRetailPrice: 15e4,
    discountAmount: 28755,
    discountPercent: "-19%"
  },
  stockQuantity: 1e3,
  selectPromotionId: 0,
  link: {
    as: {
      pathname: "/linhptn-tra-xanh-c2-oi-hong-chanh-day-455ml--s250301535",
      query: {}
    },
    href: { pathname: "/products/[sku]", query: { sku: "250301535" } },
    passHref: true
  },
  bestComboDiscount: "0",
  numberDisplayFormat: { thousandSeparator: ".", decimalSeparator: "," },
  precisionToDisplayDecimalQuantity: 0,
  showContact: false
};
const LIST_PRODUCT_REVIEW_EXAMPLE = [
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "1",
    sellerSku: "LINH004",
    name: "Tr\xE0 xanh C2 \u1ED5i h\u1ED3ng chanh d\xE2y 455ml"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "2",
    sellerSku: "seller2",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 2"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "3",
    sellerSku: "seller3",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 3"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "4",
    sellerSku: "seller4",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 4"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "5",
    sellerSku: "seller5",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 5"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "6",
    sellerSku: "seller6",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 6"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "7",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "8",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "9",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  }),
  __spreadProps(__spreadValues({}, PRODUCT_REVIEW_EXAMPLE), {
    sku: "10",
    sellerSku: "seller7",
    name: "\u0110\xE2y l\xE0 s\u1EA3n ph\u1EA9m preview 7"
  })
];
const PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL = {
  ["row"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    gutter: [0, 0],
    widthType: "full",
    contentWidthType: "fixed",
    row: {
      commonStyle: {
        maxWidth: 1232
      }
    },
    desktop: {
      gutter: [0, 0],
      commonStyle: style.DESKTOP_COMMON_STYLE
    },
    mobile: {
      gutter: [0, 0],
      commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
        padding: {
          left: 8,
          right: 8
        }
      })
    }
  },
  ["col_left"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    md: {
      flex: "50%"
    },
    xs: {
      flex: "50%"
    },
    desktop: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 4,
          bottom: 0,
          left: 0,
          main: 0
        }
      }
    },
    mobile: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 4,
          bottom: 0,
          left: 0,
          main: 0
        }
      }
    }
  },
  ["col_right"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    md: {
      flex: "50%"
    },
    xs: {
      flex: "50%"
    },
    desktop: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 4,
          main: 0
        }
      }
    },
    mobile: {
      commonStyle: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          main: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 4,
          main: 0
        }
      }
    }
  },
  ["omni_videopreviewlist"]: {
    responsive: {
      hiddenXs: false,
      hiddenMd: false
    },
    widthType: "fullWidth",
    layout: "overlay",
    displayType: "short_description",
    titleColor: "#000000",
    viewMoreStyle: {
      color: "#000000"
    },
    items: [
      {
        videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
        title: "video preview 1",
        description: "N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n"
      },
      {
        videoUrl: "https://storage.googleapis.com/develop-teko-storage/media/video/2025/10/22/27291001-31aa-4136-b8e2-a9170bf51da5/video%20mp4.mp4",
        title: "video preview 2",
        description: "N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n N\u1ED9i dung m\xF4 t\u1EA3 N\u1ED9i dung m\xF4 t\u1EA3\n"
      }
    ],
    maxWidth: 1232,
    itemStyle: {
      borderRadius: 12
    },
    desktop: {
      itemPerView: 5
    },
    mobile: {
      itemPerView: 2
    },
    title: "Video Preview",
    viewMoreUrl: "",
    commonStyle: {
      background: "rgba(255,255,255,1)"
    }
  }
};
var VideoPlatform = /* @__PURE__ */ ((VideoPlatform2) => {
  VideoPlatform2["YouTube"] = "YouTube";
  VideoPlatform2["Facebook"] = "Facebook";
  VideoPlatform2["TikTok"] = "TikTok";
  VideoPlatform2["Upload"] = "Upload";
  return VideoPlatform2;
})(VideoPlatform || {});
const VIDEO_PLATFORM = [
  "YouTube" /* YouTube */,
  "Facebook" /* Facebook */,
  "TikTok" /* TikTok */,
  "Upload" /* Upload */
];

exports.DEFAULT_VIDEO_PREVIEW_LIST = DEFAULT_VIDEO_PREVIEW_LIST;
exports.LIST_PRODUCT_REVIEW_EXAMPLE = LIST_PRODUCT_REVIEW_EXAMPLE;
exports.MAX_VIDEO_ITEM_MOBILE = MAX_VIDEO_ITEM_MOBILE;
exports.PRODUCT_REVIEW_EXAMPLE = PRODUCT_REVIEW_EXAMPLE;
exports.PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL = PROPS_DEFAULT_LAYOUT_VIDEO_PREVIEW_TWO_COL;
exports.VIDEO_PLATFORM = VIDEO_PLATFORM;
exports.VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP = VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP;
exports.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE = VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE;
exports.VIDEO_PREVIEW_ITEM_STYLE = VIDEO_PREVIEW_ITEM_STYLE;
exports.VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP = VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP;
exports.VideoPlatform = VideoPlatform;
exports.VideoPreviewDisplayType = VideoPreviewDisplayType;
exports.VideoPreviewLayout = VideoPreviewLayout;
exports.VideoPreviewWidthType = VideoPreviewWidthType;


/***/ }),

/***/ 999072:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VideoPreviewListContext = React.createContext({});
const VideoPreviewListProvider = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListContext.Provider, {
    value: __spreadValues({}, rest),
    children
  });
};

exports.VideoPreviewListContext = VideoPreviewListContext;
exports.VideoPreviewListProvider = VideoPreviewListProvider;


/***/ }),

/***/ 866045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var icons = __webpack_require__(225956);
var useModalPreviewVideo = __webpack_require__(442346);
var ModalPreviewVideo = __webpack_require__(919676);
var VideoPreviewItem = __webpack_require__(342925);
var constants = __webpack_require__(402714);
var context = __webpack_require__(999072);
var utils = __webpack_require__(63479);
var grid = __webpack_require__(793767);
var Container = __webpack_require__(739890);
var Slider = __webpack_require__(699332);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const parseProductSkus = (skuString) => {
  if (!skuString)
    return [];
  return skuString.split(",").map((sku) => sku.trim()).filter((sku) => !!sku && typeof sku === "string");
};
const VideoPreviewList = (props) => {
  var _a;
  const skus = (_a = props == null ? void 0 : props.items) == null ? void 0 : _a.flatMap(
    (item) => parseProductSkus(item == null ? void 0 : item.productSkus)
  );
  const { mappingDynamicSlots } = coreRenderer.useStore();
  const VideoPreviewCompSlot = mappingDynamicSlots == null ? void 0 : mappingDynamicSlots["video_preview_carouse"];
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: VideoPreviewCompSlot ? /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewCompSlot, {
      as: VideoPreviewListWithPropsOmni,
      asProps: props,
      skus
    }) : /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListWithPropsOmni, __spreadValues({}, props))
  });
};
const VideoPreviewListWithPropsOmni = (props) => {
  const { device } = coreRenderer.useStore();
  const _a = coreRenderer.getPropsByDevice(props, device), {
    itemPerView,
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH,
    isTwoColumnLayout
  } = _a, rest = __objRest(_a, [
    "itemPerView",
    "commonStyle",
    "maxWidth",
    "isTwoColumnLayout"
  ]);
  const { padding, margin } = commonStyle || {};
  const {
    title = "",
    viewMoreUrl = "",
    hideBuyNowButton = false,
    items = []
  } = (props == null ? void 0 : props.secondColumn) || {};
  const basePropsTwoColumn = __spreadProps(__spreadValues({}, props), {
    mobile: __spreadProps(__spreadValues({}, props.mobile), {
      itemPerView: 2
    })
  });
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin },
    maxWidth
  }, rest), {
    children: !isTwoColumnLayout ? /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues({}, props)) : /* @__PURE__ */ jsxRuntime.jsxs(TwoColumnLayoutStyled, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues(__spreadValues({}, props), basePropsTwoColumn)),
        /* @__PURE__ */ jsxRuntime.jsx(VideoPreviewListBase, __spreadValues(__spreadValues(__spreadValues({}, props), basePropsTwoColumn), { title, viewMoreUrl, hideBuyNowButton, items }))
      ]
    })
  }));
};
const VideoPreviewListBase = (props) => {
  var _c;
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const isMobile = device === "mobile";
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const wrapperMobileRef = React.useRef(null);
  const [widthWrapperMobile, setWidthWrapperMobile] = React.useState(null);
  const [isPaddingSmall, setIsPaddingSmall] = React.useState(false);
  const _a = props, {
    isEditingMode,
    title,
    viewMoreUrl,
    hideBuyNowButton = false,
    items = [],
    itemStyle,
    viewMoreStyle,
    titleColor = constants.DEFAULT_VIDEO_PREVIEW_LIST.titleColor,
    alignment = constants.VideoPreviewWidthType.FullWidth,
    layout = constants.VideoPreviewLayout.Vertical,
    displayType = constants.VideoPreviewDisplayType.ProductCard,
    widthType,
    products = [],
    productsLoading = false,
    buyNow,
    addToCart,
    isTwoColumnLayout
  } = _a, restProps = __objRest(_a, [
    "isEditingMode",
    "title",
    "viewMoreUrl",
    "hideBuyNowButton",
    "items",
    "itemStyle",
    "viewMoreStyle",
    "titleColor",
    "alignment",
    "layout",
    "displayType",
    "widthType",
    "products",
    "productsLoading",
    "buyNow",
    "addToCart",
    "isTwoColumnLayout"
  ]);
  const {
    currentVideoFocus,
    showModalPreview,
    setShowModalPreview,
    showListProductPreview,
    setShowListProductPreview,
    handleFocusVideo,
    handleShowListProductReview
  } = useModalPreviewVideo.useModalPreviewVideo({ isEditingMode });
  const spacingItem = isMobile ? constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE : constants.VIDEO_PREVIEW_DEFAULT_SPACING_DESKTOP;
  const productMap = React.useMemo(() => {
    const result = {};
    products == null ? void 0 : products.forEach((product) => {
      const { sku } = product || {};
      if (sku)
        result[sku] = product;
    });
    return result;
  }, [JSON.stringify(products)]);
  const videosFormatted = React.useMemo(() => {
    const getProductReviews = (skus) => {
      var _a2, _b2, _c2;
      if (isEditingMode || isPreviewMode)
        return constants.LIST_PRODUCT_REVIEW_EXAMPLE.slice(
          0,
          ((_a2 = skus == null ? void 0 : skus.split(",")) == null ? void 0 : _a2.length) || 1
        );
      return ((_c2 = (_b2 = skus == null ? void 0 : skus.split(",")) == null ? void 0 : _b2.map(
        (sku) => {
          var _a3;
          return productMap == null ? void 0 : productMap[(_a3 = sku == null ? void 0 : sku.toString()) == null ? void 0 : _a3.trim()];
        }
      )) == null ? void 0 : _c2.filter(Boolean)) || [];
    };
    const isHiddenWhenNotFoundProduct = !isEditingMode && !isPreviewMode;
    return items == null ? void 0 : items.map((item) => __spreadProps(__spreadValues({}, item), {
      productReviews: getProductReviews(item == null ? void 0 : item.productSkus)
    })).filter((item) => {
      var _a2, _b2;
      if (isHiddenWhenNotFoundProduct) {
        return (productsLoading || ((_a2 = item == null ? void 0 : item.productReviews) == null ? void 0 : _a2.length) || !((_b2 = item == null ? void 0 : item.productSkus) == null ? void 0 : _b2.length)) && item.videoUrl;
      }
      return true;
    });
  }, [
    JSON.stringify(products),
    JSON.stringify(items),
    isEditingMode,
    isPreviewMode,
    productsLoading
  ]);
  const { itemPerView, commonStyle } = coreRenderer.getPropsByDevice(restProps, device);
  const hiddenPlayButton = isMobile && itemPerView >= 3;
  const widthSlideWrapper = React.useMemo(() => {
    if (widthType === constants.VideoPreviewWidthType.FullWidth)
      return "100%";
    if (itemPerView)
      return itemPerView * constants.VIDEO_PREVIEW_ITEM_WIDTH_DEFAULT_DESKTOP + spacingItem * Math.ceil(itemPerView - 1);
  }, [itemPerView, widthType, spacingItem]);
  const _b = commonStyle || {}, restStyle = __objRest(_b, ["padding", "margin"]);
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  const widthVideoItemMobile = React.useMemo(() => {
    const isClient = typeof window !== "undefined";
    if (!isClient)
      return 250;
    const itemPerViewComputed = Math.min(itemPerView, constants.MAX_VIDEO_ITEM_MOBILE);
    const widthItem = (widthWrapperMobile - (Math.ceil(itemPerViewComputed) - 1) * constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE) / itemPerViewComputed;
    if (displayType === constants.VideoPreviewDisplayType.ShortDescription)
      return widthItem;
    return Math.max(widthItem, 250) || 250;
  }, [itemPerView, widthWrapperMobile, displayType, isMobile]);
  const isShowListVideoItem = displayType === constants.VideoPreviewDisplayType.ProductCard || widthWrapperMobile;
  React.useEffect(() => {
    if (!wrapperMobileRef.current)
      return;
    const el = wrapperMobileRef.current;
    const updateWidth = () => {
      var _a2;
      const width = (_a2 = el == null ? void 0 : el.getBoundingClientRect()) == null ? void 0 : _a2.width;
      if (width)
        setWidthWrapperMobile(Math.round(width));
    };
    const debouncedUpdateWidth = isEditingMode ? coreRenderer.debounce(updateWidth, 200) : updateWidth;
    const observer = new ResizeObserver(() => {
      debouncedUpdateWidth();
    });
    requestAnimationFrame(() => {
      debouncedUpdateWidth();
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [isMobile, isEditingMode, wrapperMobileRef.current]);
  React.useEffect(() => {
    const isPaddingSmall2 = isTwoColumnLayout || widthWrapperMobile < 250;
    if (isPaddingSmall2)
      setIsPaddingSmall(true);
  }, [isPaddingSmall, widthWrapperMobile]);
  const isHiddenBlock = !(videosFormatted == null ? void 0 : videosFormatted.length) && !isEditingMode;
  return /* @__PURE__ */ jsxRuntime.jsxs(context.VideoPreviewListProvider, {
    buyNow,
    addToCart,
    handleShowListProductReview,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        commonStyle: __spreadProps(__spreadValues({
          backgroundSize: "cover"
        }, restStyle), {
          background: isHiddenBlock ? "transparent" : restStyle == null ? void 0 : restStyle.background
        }),
        style: {
          padding: isPaddingSmall ? "8px 8px" : "8px 16px",
          borderRadius: 8
        },
        children: [
          (title || viewMoreUrl) && !isHiddenBlock ? /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            children: [
              /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
                style: { color: titleColor },
                children: title
              }),
              viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
                style: {
                  color: (viewMoreStyle == null ? void 0 : viewMoreStyle.color) || constants.DEFAULT_VIDEO_PREVIEW_LIST.viewMoreStyle.color
                },
                onClick: () => handleClickUrl(viewMoreUrl),
                children: [
                  isTwoColumnLayout || isMobile ? null : "Xem t\u1EA5t c\u1EA3",
                  /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                    style: { fontSize: 16 },
                    name: "RightOutlined"
                  })
                ]
              })
            ]
          }) : null,
          isMobile ? /* @__PURE__ */ jsxRuntime.jsx(VideoListWrapper, {
            isEditingMode,
            widthVideoItemMobile,
            ref: wrapperMobileRef,
            children: isShowListVideoItem ? videosFormatted == null ? void 0 : videosFormatted.map((item, index) => /* @__PURE__ */ React.createElement(VideoPreviewItem.VideoPreviewItem, __spreadProps(__spreadValues({}, item), {
              key: index,
              itemStyle,
              isEditingMode,
              layout,
              displayType,
              onClick: () => handleFocusVideo(item),
              hiddenPlayButton,
              hideBuyNowButton
            }))) : /* @__PURE__ */ jsxRuntime.jsx("div", {
              style: { width: "100%" }
            })
          }) : /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
            style: { alignItems: (_c = grid.MAPPING_ALIGNMENT_FLEX) == null ? void 0 : _c[alignment] },
            children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
              onMouseEnter: () => setShowNavBtns(true),
              onMouseLeave: () => setShowNavBtns(false),
              style: {
                position: "relative",
                width: typeof widthSlideWrapper === "number" ? `min(${widthSlideWrapper}px, 100%)` : widthSlideWrapper
              },
              children: [
                (videosFormatted == null ? void 0 : videosFormatted.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                  className: "left-nav",
                  style: { opacity: showNavBtns ? 1 : 0 },
                  ref: navigationPrevRef
                }),
                /* @__PURE__ */ jsxRuntime.jsx(SliderStyled, {
                  navigation: {
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current
                  },
                  slidesPerView: "auto",
                  navigationStyle: 1,
                  paginationColor: "#ffffff",
                  allowTouchMove: !isEditingMode,
                  onBeforeInit: (swiper) => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                  },
                  spaceBetween: spacingItem,
                  children: videosFormatted == null ? void 0 : videosFormatted.map((item, index) => /* @__PURE__ */ React.createElement(VideoPreviewItem.VideoPreviewItem, __spreadProps(__spreadValues({}, item), {
                    key: index,
                    itemStyle,
                    isEditingMode,
                    layout,
                    displayType,
                    onClick: () => handleFocusVideo(item),
                    hiddenPlayButton,
                    hideBuyNowButton
                  })))
                }),
                (videosFormatted == null ? void 0 : videosFormatted.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
                  className: "right-nav",
                  style: { opacity: showNavBtns ? 1 : 0 },
                  ref: navigationNextRef
                })
              ]
            })
          })
        ]
      }),
      showModalPreview && /* @__PURE__ */ jsxRuntime.jsx(ModalPreviewVideo.ModalPreviewVideo, {
        videoPreview: currentVideoFocus,
        show: showModalPreview,
        cancel: () => {
          setShowModalPreview(false);
          setShowListProductPreview(false);
        },
        itemStyle,
        isEditingMode,
        layout,
        displayType,
        showListProductPreview,
        cancelShowListProductPreview: () => {
          setShowListProductPreview(false);
        },
        hideBuyNowButton
      })
    ]
  });
};
VideoPreviewList.displayName = "Omni_VideoPreviewList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
const SliderWrapper = styled__default["default"].div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TitleStyled = styled__default["default"].div`
  ${utils.getClampedTextStyle(1)}
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 16px 0 0;
`;
const VideoListWrapper = styled__default["default"].div(
  ({ isEditingMode, widthVideoItemMobile }) => `
  display: grid;
  width: 100%;
  column-gap: ${constants.VIDEO_PREVIEW_DEFAULT_SPACING_MOBILE}px;
  overflow-x: scroll;
  overflow-y: hidden;
  grid-auto-flow: column;
  grid-auto-columns: ${widthVideoItemMobile}px;
  & > div {
    width: unset !important;
  }


  &::-webkit-scrollbar {
    height: 8px;
    ${!isEditingMode ? "display: none;" : ""}
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`
);
const NavigationButtonStyled = styled__default["default"].div`
  top: 50%;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 460px) {
    margin-bottom: 12px;
  }
`;
const ViewAll = styled__default["default"].div`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;
const SliderStyled = styled__default["default"](Slider.Slider)(
  () => `
   .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
  }

`
);
const TwoColumnLayoutStyled = styled__default["default"].div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

exports.VideoPreviewList = VideoPreviewList;
exports.parseProductSkus = parseProductSkus;


/***/ }),

/***/ 63479:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const getClampedTextStyle = (lines) => `
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  line-clamp: ${lines};
  -webkit-box-orient: vertical;
  line-height: 1.5;
  word-break: break-all;
`;
const getFirstFrameBlob = async (videoUrl) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.src = `${videoUrl}#t=0.001`;
    video.muted = true;
    video.playsInline = true;
    const getFrame = () => {
      try {
        const width = Math.max(video.videoWidth, 500);
        const height = width * 16 / 9;
        if (!width || !height) {
          return reject(new Error("Kh\xF4ng l\u1EA5y \u0111\u01B0\u1EE3c k\xEDch th\u01B0\u1EDBc video"));
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject(new Error("Kh\xF4ng t\u1EA1o \u0111\u01B0\u1EE3c blob t\u1EEB canvas"));
            }
            const file = new File([blob], "thumbnail.jpg", {
              type: "image/jpeg"
            });
            resolve(file);
          },
          "image/jpeg",
          0.9
        );
      } catch (err) {
        reject(err);
      }
    };
    video.addEventListener("canplay", () => setTimeout(getFrame, 500));
    video.addEventListener("error", () => {
      reject(new Error("error load video"));
    });
  });
};

exports.getClampedTextStyle = getClampedTextStyle;
exports.getFirstFrameBlob = getFirstFrameBlob;


/***/ })

}]);